<template>
  <div class="ibox">

			<a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
				Show Filters <i class="fa fa-bars"></i>
			</a>
			<div class="ibox-results-filters-collapse-box collapse in">
				<div class="ibox-results-filters">
					<div class="row">
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="control-label">Keyword</label>
								<input type="text" class="form-control" placeholder="Location Name or Keyword" @input="updateKeywords"/>
							</div>
						</div>
						<div class="col-sm-6 col-lg-3">
							<div class="form-group">
								<label class="control-label">Order</label>
                <selectize
                class="select2-material-placeholder-search"
                placeholder="- Select -"
                :options="orderOptions"
                name="order"
                @input="updateOrder">
                </selectize>
		  				</div>
						</div>
					</div><!-- /.row -->
				</div><!-- /.ibox-results-filters -->
			</div><!-- /.ibox-results-filters-collapse-box -->
			<div class="ibox-results-filters">
				<p class="no-margin">Please contact Arrow Logistics for more details on current jobs available:</p>
			</div>
			<div class="ibox-content">
        <ul class="list-detail list-detail-public-job">
          <job-board-list-item v-for="job in jobsDecorated" :job="job" :key="job.id"></job-board-list-item>
        </ul>

        <div class="text-center text-muted" v-show="haveNoJobs">
          <strong>There are no jobs.</strong>
        </div>
			</div>
      <lazy-loading v-show="haveJobs" :reached-bottom="getJobBoardItemsForNextPage" :filters="filters" ref="lazyLoading">
        <strong slot="finished" class="text-muted">There are no more jobs.</strong>
      </lazy-loading>

      <job-board-modal></job-board-modal>
		</div><!-- /.ibox -->
</template>

<script>
import { Selectize } from 'components/forms'
import { mapActions, mapState, mapGetters } from 'vuex'
import { debounce, isEqual } from 'lodash'
import { notify } from 'utils'
import { LazyLoading } from 'components/misc'
import JobBoardListItem from './JobBoardListItem'
import JobBoardModal from './JobBoardModal'

export default {
  data () {
    return {
      order: null,
      keywords: null
    }
  },

  components: {
    Selectize,
    JobBoardListItem,
    LazyLoading,
    JobBoardModal
  },

  computed: {
    ...mapState('job', ['jobs', 'pagination']),
    ...mapGetters('job', ['jobsDecorated']),

    filters () {
      return {
        keywords: this.keywords,
        order: this.order
      }
    },

    /**
     * The sorting Options
     */
    orderOptions () {
      return [
        { id: 'newest', text: 'Newest First' },
        { id: 'oldest', text: 'Oldest First' },
        { id: 'largest', text: 'Largest Quantity' },
        { id: 'smallest', text: 'Smallest Quantity' }
      ]
    },

    /**
     * Determine if we have no jobs.
     *
     * @return boolean
     */
    haveNoJobs () {
      return this.jobs.length === 0
    },

    /**
     * Determine if we have jobs.
     *
     * @return boolean
     */
    haveJobs () {
      return this.jobs.length > 0
    }
  },

  created () {
    this.getJobBoardItems(this.filters)
  },

  watch: {
    /**
     * Watch filters for deep changes, refetch jobs if they change.
     *
     * @type Object
     */
    filters: {
      handler (newFilters, oldFilters) {
        if (isEqual(newFilters, oldFilters)) {
          return
        }

        // Reset the lazy loading component so that it will attempt to load
        // more jobs as we scroll again.
        const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

        this.getJobBoardItems(this.filters).then(resetLazyLoading).catch(this.failedToLoadJobs)
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('job', ['getJobBoardItems', 'getJobBoardItemsForNextPage']),

    /**
     * Failed to load jobs.
     *
     * @return void
     */
    failedToLoadJobs () {
      notify.error('There was a problem loading the jobs.')
    },

    /**
     * Debounce updating of keywords so we don't poll API immediately for new jobs.
     *
     * @param object event
     *
     * @return Function
     */
    updateKeywords: debounce(function (event) {
      this.keywords = event.target.value
    }, 800),

    /**
     * Debounce updating of order reference so we don't poll API immediately for new jobs.
     *
     * @param object event
     *
     * @return Function
     */
    updateOrder: debounce(function (value) {
      this.order = value
    }, 800)
  }
}
</script>



// WEBPACK FOOTER //
// JobBoard.vue?700d8ac6